import { useContext, useEffect, useState } from 'react';
import { UserContext } from 'context/userContext';
import { getKenoAccess } from 'services/api/kenoService';

// One request per logged-in player per page load; every menu that shows the
// Keno entry shares it.
let cached: { userId: number; enabled: Promise<boolean> } | null = null;

export function useKenoAccess(): boolean {
  const { loggedUser } = useContext(UserContext);
  const userId: number | undefined = loggedUser?.id;
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    if (!userId) {
      setEnabled(false);
      return;
    }
    if (!cached || cached.userId !== userId) {
      cached = { userId, enabled: getKenoAccess().catch(() => false) };
    }
    let live = true;
    cached.enabled.then((v) => live && setEnabled(v));
    return () => {
      live = false;
    };
  }, [userId]);
  return enabled;
}
